import React from "react";
import classNames from "classnames";
import { useKeyboardCommand } from "@hooks/keyboard/useKeyboardCommand";
import { Button } from "@design-system/Button/Button";
import { WithHotkey } from "@design-system/Button/WithHotkey";
import { StandardModalHeader } from "@design-system/Modal/Modal";
import { GrowthIcon, DollarCircleIcon, SignIcon } from "@icons";
import commonStyles from "../../steps/common.module.scss";
import styles from "./ConnectPrivateAccounts.module.scss";

interface ConnectPrivateAccountsProps {
    onContinue(): void;
}

export const ConnectPrivateAccounts: React.FC<ConnectPrivateAccountsProps> = ({
    onContinue,
}) => {
    useKeyboardCommand({
        keys: "enter",
        callback: onContinue,
        options: {
            description: "Continue to Accounts",
        },
    });

    return (
        <>
            <StandardModalHeader>
                <div>
                    Don't forget to add your{" "}
                    <em className={commonStyles.highlight}>
                        personal accounts
                    </em>
                </div>
            </StandardModalHeader>

            <p className="mb-4">Here's why this step is important:</p>
            <ul className={classNames("list-unstyled", styles.list)}>
                <li className={styles.item}>
                    <span className={styles.icon}>
                        <GrowthIcon />
                    </span>
                    Ensure accurate financials by auto matching Transfers.
                </li>

                <li className={styles.item}>
                    <span className={styles.icon}>
                        <DollarCircleIcon />
                    </span>
                    <span>
                        Don’t miss out on tax savings–users save{" "}
                        <em className={commonStyles.highlight}>$4k</em> on
                        average.
                    </span>
                </li>

                <li className={styles.item}>
                    <span className={styles.icon}>
                        <SignIcon />
                    </span>
                    Handle Meals, Travel and Home Office tax deductions.
                </li>
            </ul>

            <footer className={styles.footer}>
                <WithHotkey
                    hotKey="enter"
                    hotKeyOptions={{ description: "Continue to Accounts" }}
                    hotKeyDisplayPosition="inline"
                >
                    {(hotkeyHint) => (
                        <Button
                            variant="primary"
                            onClick={onContinue}
                            size="xl"
                            rightIcon={hotkeyHint}
                        >
                            Continue to Accounts
                        </Button>
                    )}
                </WithHotkey>
            </footer>
        </>
    );
};
